<template>
  <div>
    <p class="title-page">Lista de Códigos de Serviços que <b>não lançará</b> no Grupo 4</p>
    <TableBlock />
  </div>
</template>

<script>
import TableBlock from "../components/TableCodigoServico.vue";

export default {
  name: "codigoServicoG4",

  components: {
    TableBlock,
  },
};
</script>
